import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import axios from "axios";
export default {
  name: "getFurnaceNo",
  data: function data() {
    return {
      data: [// {
        //   sId: 7,
        //   productDate: "2203",
        //   totalCount: 201,
        //   firstGoodCount: 1,
        //   firstGoodRate: 5,
        //   totalCheckCount: 5,
        //   totalGoodCount: 1,
        //   totalScrapCount: 2,
        //   status: "探伤中",
        //   defaultType: [
        //     {
        //       name: "焊后",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "焊后",
        //           place: "车顶",
        //           value: "1",
        //         },
        //         {
        //           id: 27,
        //           defectType: "焊后",
        //           place: "车尾",
        //           value: "1",
        //         },
        //       ],
        //     },
        //     {
        //       name: "接缝",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "接缝",
        //           place: "舌钩",
        //           value: "1",
        //         },
        //         {
        //           id: 27,
        //           defectType: "接缝",
        //           place: "蛇头",
        //           value: "1",
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {
        //   sId: 8,
        //   productDate: "2203",
        //   totalCount: 31,
        //   firstGoodCount: 11,
        //   firstGoodRate: 50,
        //   totalCheckCount: 75,
        //   totalGoodCount: 1,
        //   totalScrapCount: 2,
        //   status: "探伤中",
        //   defaultType: [
        //     {
        //       name: "焊后",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "焊后",
        //           place: "车顶",
        //           value: "7",
        //         },
        //         {
        //           id: 27,
        //           defectType: "焊后",
        //           place: "车尾",
        //           value: "",
        //         },
        //       ],
        //     },
        //     {
        //       name: "接缝",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "接缝",
        //           place: "舌钩",
        //           value: "10",
        //         },
        //         {
        //           id: 27,
        //           defectType: "接缝",
        //           place: "蛇头",
        //           value: "1",
        //         },
        //       ],
        //     },
        //     {
        //       name: "车顶",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "车顶",
        //           place: "下马",
        //           value: "10",
        //         },
        //         {
        //           id: 27,
        //           defectType: "车顶",
        //           place: "上马",
        //           value: "1",
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {
        //   sId: 18,
        //   productDate: "2208",
        //   totalCount: 1,
        //   firstGoodCount: 1,
        //   firstGoodRate: 5,
        //   totalCheckCount: 155,
        //   totalGoodCount: 16,
        //   totalScrapCount: 27,
        //   status: "探伤中",
        //   defaultType: [
        //     {
        //       name: "焊后",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "焊后",
        //           place: "车顶",
        //           value: "7",
        //         },
        //       ],
        //     },
        //     {
        //       name: "接缝",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "接缝",
        //           place: "舌钩",
        //           value: "1100",
        //         },
        //         {
        //           id: 27,
        //           defectType: "接缝",
        //           place: "蛇头",
        //           value: "1",
        //         },
        //         {
        //           id: 28,
        //           defectType: "接缝",
        //           place: "下档",
        //           value: "1",
        //         },
        //       ],
        //     },
        //     {
        //       name: "车顶",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "车顶",
        //           place: "下马",
        //           value: "1",
        //         },
        //         {
        //           id: 27,
        //           defectType: "车顶",
        //           place: "上马",
        //           value: "111",
        //         },
        //         {
        //           id: 29,
        //           defectType: "车顶",
        //           place: "马中间",
        //           value: "715",
        //         },
        //       ],
        //     },
        //     {
        //       name: "车尾根",
        //       smallClass: [
        //         {
        //           id: 26,
        //           defectType: "车尾根",
        //           place: "车尾根1",
        //           value: "10",
        //         },
        //         {
        //           id: 27,
        //           defectType: "车尾根",
        //           place: "车尾根2",
        //           value: "1",
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
      MaterialList: [],
      productlist: [],
      areaDate: null,
      model: {
        endDate: "",
        startDate: "",
        productNumber: "",
        sId: ""
      },
      row: "",
      fileToken: ""
    };
  },
  computed: {
    getMaxIndex: function getMaxIndex() {
      var maxIndex = 0;
      var len = 0;
      this.data.forEach(function (item, index) {
        if (item.defaultType.length > len) {
          len = item.defaultType.length;
          maxIndex = index;
        }
      });
      return maxIndex;
    }
  },
  watch: {
    areaDate: function areaDate(val) {
      if (val && val.length !== 0) {
        this.model.startDate = val[0];
        this.model.endDate = val[1];
      }
    }
  },
  components: {},
  mounted: function mounted() {
    if (this.$route.query.sId) {
      this.sId = this.$route.query.sId;
      this.model.sId = this.$route.query.sId;
    } // this.query();

  },
  methods: {
    fillFurnace: function fillFurnace(sId) {
      if (sId < 10000) {
        var sIdStr = "000" + sId;
        return sIdStr.slice(-4);
      } else {
        return sId;
      }
    },
    handleCurrentChange: function handleCurrentChange(row) {
      this.row = row;
    },
    query: function query() {
      var _this = this;

      for (var key in this.model) {
        if (this.model[key] === "") {
          delete this.model[key];
        } else {
          if (key === "sId") {
            if (!parseInt(this.model[key])) {
              $gb.tip("炉号请输入数值", "warning");
              return false;
            }
          }

          if (key === "productNumber") {
            if (!parseInt(this.model[key])) {
              $gb.tip("产品编号请输入数值", "warning");
              return false;
            }
          }
        }
      }

      $api.furnaceStatistics(this.model).then(function (res) {
        console.log(res, "furnaceStatisticsRes");

        if (res.statusCode !== 0) {
          $gb.tip(res.msg, "error");
          return false;
        }

        $gb.tip(res.msg);
        _this.data = res.data;
        _this.fileToken = res.fileToken;
      });
    },
    resetForm: function resetForm() {
      this.model = {
        endDate: "",
        startDate: "",
        productNumber: "",
        sId: ""
      };
      this.row = "";
      this.areaDate = null;
      this.query();
    },
    productNumber: function productNumber(row) {
      if (row.endNumber !== 0 || row.startNumber !== 0) {
        var startStr = "000" + row.startNumber;
        var endStr = "000" + row.endNumber;
        return startStr.slice(-4) + "-" + endStr.slice(-4);
      } else {
        return row.productNumbers;
      }
    },
    heatNumberDetails: function heatNumberDetails() {
      console.log(this.row);

      if (!this.row) {
        $gb.tip("请至少选择一个炉号", "warning");
        return false;
      }

      this.$router.push({
        path: "/inspection",
        query: {
          sId: this.row.sId
        }
      });
    },
    handleData: function handleData(row, i1, i2, i3) {
      var res = "";

      if (row.defaultType) {
        if (row.defaultType[i2]) {
          if (row.defaultType[i2].smallClass[i3]) {
            res = row.defaultType[i2].smallClass[i3].value;
          }
        }
      }

      return res;
    },
    download: function download() {
      var _this2 = this;

      var token = window.sessionStorage.getItem("token");
      var filetoken = this.fileToken;

      if (!filetoken) {
        $gb.tip("请先搜索数据后下载", "warning");
        return false;
      }

      var url = process.env.NODE_ENV !== "production" ? "http://175.24.227.116:8080" : $platform.api;
      axios.get("/scovfile/".concat(token, "/").concat(filetoken), {
        responseType: "blob",
        baseURL: url,
        timeout: 0
      }).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "".concat(_this2.model.sId ? "炉号" + _this2.model.sId : "", "\u63A2\u4F24\u7EDF\u8BA1\u6570\u636E") + ".xlsx");
        document.body.appendChild(link);
        link.click();
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
};